import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_provider/provider/jobs/")({
  component: RouteComponent,
  beforeLoad: () => {
    throw redirect({
      to: "/provider/jobs/active",
    });
  },
});

function RouteComponent() {
  return <div>Hello "/_provider/provider/jobs/"!</div>;
}
